import { observer } from 'mobx-react-lite'
import cx from 'classnames'
import { CommentableType } from 'components/ActivityEvent/Types'
import { CommentV2 } from 'components/CommentV2/CommentV2'
import { Todo } from 'components/Todo/Todo'
import { useRootStore } from 'stores/RootStore'
import { useDocStore } from 'stores/DocStore'
import Styles from 'components/DocModes/RightRail/RightRail.module.scss'
import CleanupStyles from './CleanupRightRail.module.scss'
import { MaybeTrackedChange } from 'components/DocRightRailV2/MaybeTrackedChange/MaybeTrackedChange'
import { sortBy } from 'lodash'
import { CollabItemType } from 'stores/DocStore.types'
import { BottomMessage } from './BottomMessage'
import { Actions } from './Actions'
import { useCurrentLayer } from '../../hooks/useCurrentLayer'
import { LayerActions } from './LayerActions'
import { ProgressBar } from './ProgressBar'
import { RightRail } from 'components/DocModes/RightRail'
import { ReactComponent as CleanupIcon } from 'assets/icons/cleanup16.svg'
import { CollapseButton } from 'components/DocModes/RightRail/CollapseButton/CollapseButton'
import { useLayout } from '../../stores/LayoutStore'

const CleanupRightRail = observer(() => {
  const rootStore = useRootStore()
  const docStore = useDocStore()
  const currentLayer = useCurrentLayer({ articleKey: docStore.articleId })
  const layout = useLayout()

  const cleanedUpItemsCount = docStore?.cleanupModeStore.cleanedUpItemsCount
  const outstandingItems = docStore?.cleanupModeStore.outstandingItems
  const thereAreItemsToCleanUp = outstandingItems - cleanedUpItemsCount > 0

  if (!docStore || !currentLayer) return null

  return (
    <RightRail.Root>
      <RightRail.Header>
        <div className={Styles.upperHeader}>
          <div className={CleanupStyles.labelContent}>
            <CleanupIcon className={cx(Styles.icon, CleanupStyles.icon)} />
            <span className={Styles.headerLabel}>Clean up</span>
            <ProgressBar />
          </div>
          {layout.rightColumnLocked && <CollapseButton />}
        </div>
        {currentLayer.is_main ? <Actions /> : <LayerActions />}
      </RightRail.Header>

      <RightRail.ScrollContent>
        {thereAreItemsToCleanUp &&
          docStore.cleanupModeStore.orderedCollabItemsForCleanup.map(({ item, type }) => {
            switch (type) {
              case CollabItemType.Comment:
                return (
                  <div className={cx(Styles.itemWrapper)} key={`comment-${item.id}`}>
                    <CommentV2
                      inCleanupMode
                      items={[
                        item,
                        ...sortBy(rootStore.comments.getByCommentable(item.id, CommentableType.COMMENT), 'created_at'),
                      ]}
                    />
                  </div>
                )
              case CollabItemType.TrackedChange:
                return (
                  <div key={`trackedChange-${item.uuid}`}>
                    <MaybeTrackedChange trackedChange={item} inCleanupMode />
                  </div>
                )
              case CollabItemType.Todo:
                return (
                  <div className={Styles.itemWrapper} key={`todo-${item.id}`}>
                    <Todo
                      inCleanupMode
                      items={[
                        item,
                        ...sortBy(
                          docStore.rootStore.comments.getByCommentable(item.id, CommentableType.TODO),
                          'created_at',
                        ),
                      ]}
                    />
                  </div>
                )
              default:
                return null
            }
          })}
        {docStore.cleanupModeStore.collabItemsForCleanup.length < 4 && <BottomMessage />}
      </RightRail.ScrollContent>
    </RightRail.Root>
  )
})

export { CleanupRightRail }
